import { APIMethod, fetchData } from "@client";

export async function editProjectVersionComment(
  commentUuid,
  projectUuid,
  commenterUuid,
  version,
  body,
  mentions,
) {
  await fetchData(
    `v1/ws/project/comments/${commentUuid}`,
    APIMethod.PUT,
    {
      data: {
        uuid: projectUuid,
        version,
        body,
        notify: mentions,
        user: commenterUuid,
      }
    }
  );
}